import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reimpression-tpv',
  templateUrl: './reimpression-tpv.component.html',
  styleUrls: ['./reimpression-tpv.component.css']
})
export class ReimpressionTpvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
